import {inject} from '@angular/core';
import {CanActivateFn, Router, UrlTree} from '@angular/router';
import Keycloak from 'keycloak-js';

/**
 * A reusable functional route guard that checks Keycloak roles.
 *
 * Usage in routes:
 * {
 *   path: 'admin',
 *   canActivate: [roleGuard],
 *   data: { roles: ['admin', 'some_client_role'] }
 * }
 *
 * If no roles are configured on the route (data.roles is empty/undefined),
 * the guard will allow navigation.
 */
export const roleGuard: CanActivateFn = async (route): Promise<boolean | UrlTree> => {
  const keycloak = inject(Keycloak);
  const router = inject(Router);

  const requiredRoles = (route.data?.['roles'] as string[] | undefined)?.filter(Boolean) ?? [];
  if (requiredRoles.length === 0) {
    return true;
  }

  const loggedIn = keycloak.authenticated;
  if (!loggedIn) {
    await keycloak.login({redirectUri: window.location.href});
    return false;
  }

  for (const role of requiredRoles) {
    if (keycloak.hasRealmRole(role)) {
      return true;
    }
  }

  return router.parseUrl('/dashboard');
};
